export type TrxStreamType = 'all' | 'log' | 'can' | 'user_can' | 'trx'

export type TrxStreamData = {
  id: string
  fileType: string
  serialNumber: string
  instanceId: number
  // recordNumber is a PostgreSQL BIGINT; the listing endpoint's raw query
  // returns it as a string (node-postgres avoids precision loss beyond
  // Number.MAX_SAFE_INTEGER for BIGINT columns), so it isn't always a number
  // at runtime despite most values being small enough to look like one.
  recordNumber: number | string
  s3Key: string
  uploadDate: string
  processedAt: string | null
  startTime: string | null
  extent: object | null
  validityStatus: 'awaiting_processing' | 'valid' | 'invalid' | null
}

export type TrxStreamFilters = {
  type: TrxStreamType
  serialNumber: string
  instanceId: string
  recordNumber: string
  uploadFrom?: string
  uploadTo?: string
  startFrom?: string
  startTo?: string
  harvestId?: number
}

export const DEFAULT_TRX_STREAM_FILTERS: TrxStreamFilters = {
  type: 'all',
  serialNumber: '',
  instanceId: '',
  recordNumber: '',
}

export type FieldOption = {
  id: number
  name: string
  farmId: number
}

export type HarvestOption = {
  id: number
  cropYear: number
  startDate: string
  endDate: string
}
